import { ITrialClass } from '@wot/typings';
import { parseISO } from 'date-fns';
import { format } from 'date-fns/esm';
import Chip from '../../../../components/Chip';
import { TableRowItemData } from '../../../../components/Table';

export default function TableRowItem({ session, actionRequired }: { session: ITrialClass; actionRequired: boolean }) {
  return (
    <>
      <TableRowItemData text={format(parseISO(session.createdAt), 'dd/MM/yyyy')} />
      <TableRowItemData text={session._id} />
      <TableRowItemData text={session?.user?.name || ''} />
      {/* <TableRowItemData text={session?.user?.email || ""} /> */}
      <TableRowItemData text={session.category.name} />
      <TableRowItemData text={format(parseISO(session.scheduledTime.start), 'd LLL yyyy, p')} />
      <TableRowItemData text={session?.tutor?.name || ''} />
      <TableRowItemData text={session.type} />
      <TableRowItemData
        component={
          <Chip
            state={
              session.status === 'pending'
                ? 'warning'
                : session.status === 'upcoming'
                ? 'pending'
                : session.status === 'completed'
                ? 'success'
                : session.status === 'cancelled'
                ? 'error'
                : 'pending'
            }
          >
            <p className="text-sm font-semibold capitalize">{session.status}</p>
          </Chip>
        }
      />
      {actionRequired && (
        <TableRowItemData
          component={
            <Chip state={'warning'}>
              <p className="text-sm font-semibold capitalize">{session.actionRequired}</p>
            </Chip>
          }
        />
      )}
    </>
  );
}
